import { type FC } from 'react';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';

import { useSolanaWallet } from '../../hooks/useSolanaWallet';

import { ConnectedSolanaWalletButton } from './components';

export const ConnectedSolanaWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { connect, isConnected } = useSolanaWallet();

  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          connect();
        }}
        {...props}
      >
        {children || 'Connect Solana Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedSolanaWalletButton {...props} className={className}>
      {children}
    </ConnectedSolanaWalletButton>
  );
};
